import { type GetUsersResponse } from '../model/get-users-response'
import { httpClient } from './http-client'

export interface GetUsersOptions {
  query?: string | null
}

export function getUsers({ query }: GetUsersOptions = {}) {
  const searchParams = new URLSearchParams([['query', query || '']])

  const response = httpClient.get<GetUsersResponse>('users?' + searchParams.toString(), { requireAuth: true })
  const responseBody = response.json()

  return responseBody
}
